var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"mail","transform":"translate(-4.5 -7.257)"},React.createElement("path",{"id":"パス_92","data-name":"パス 92","d":"M4.509,8.146A.889.889,0,0,1,5.4,7.257H19.611a.889.889,0,0,1,.889.889V18.212a1.778,1.778,0,0,1-1.778,1.778H6.278A1.778,1.778,0,0,1,4.5,18.212V8.434a.86.86,0,0,1,.009-.124Zm1.769,1.977v8.089H18.722V10.123l-4.337,4.337a2.667,2.667,0,0,1-3.771,0L6.278,10.121Zm1.4-1.116h9.65l-4.2,4.2a.889.889,0,0,1-1.258,0l-4.2-4.2Z","fillRule":"evenodd"})));
}

Mail.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 16 12.732","stroke":"currentcolor","fill":"currentcolor","strokeWidth":"0"};

module.exports = Mail;

Mail.default = Mail;
